import React from "react";

import { Link } from "react-router-dom";
// react icons sidebar
import { AiFillHome } from "react-icons/ai";
import { BsFillPlayBtnFill } from "react-icons/bs";
import { BsFillFileEarmarkCheckFill } from "react-icons/bs";
import { MdHPlusMobiledata } from "react-icons/md";
import { BsFillPersonFill } from "react-icons/bs";
import { BsFillBookmarkFill } from "react-icons/bs";
import { GiStarShuriken } from "react-icons/gi";

import iosDownloadPic from "../../assests/images/ios-app.svg";
import androidDownloadPic from "../../assests/images/android-app.svg";

import "./Sidebar.scss";
import PATH from "../../constants/routes";
import useActivePath from "../../CustomHooks/useActivePath";

export default function Sidebar() {
  const { urlPaths, checkActive } = useActivePath();
  return (
    <div className="sidebar_container">
      <div className="sidebar_item">
        <ul>
          <li className={checkActive(PATH.HOMEPAGE)}>
            <Link to="/" className="home">
              <AiFillHome />
              Home
            </Link>
          </li>
        </ul>
      </div>
      <div className="study_module">
        <div className="sidebar_item_title">STUDY MODULE</div>
        <div className="sidebar_item">
          <ul>
            <li className={checkActive(PATH.VIDEOS)}>
              <Link to={PATH.VIDEOS} className="videos">
                <BsFillPlayBtnFill />
                Videos
              </Link>
            </li>
            <li className={checkActive(PATH.QBANK)}>
              <Link to={PATH.QBANK} className="qbank">
                <BsFillBookmarkFill />
                QBank
              </Link>
            </li>
            <li className={checkActive(PATH.TESTS)}>
              <Link to={PATH.TESTS} className="tests">
                <MdHPlusMobiledata />
                Tests
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="account_module">
        <div className="sidebar_item">
          <div className="sidebar_item_title">ACCOUNT MODULE</div>
          <ul>
            <li className="">
              <Link to="/" className="profile">
                <BsFillPersonFill />
                Me
              </Link>
            </li>
            <li className="">
              <Link to="/" className="bookmarks">
                <BsFillFileEarmarkCheckFill />
                Bookmarks
              </Link>
            </li>
            <li className="">
              <Link to="/" className="plans">
                <GiStarShuriken />
                View Plans
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="download_link_container">
        <div className="sidebar_item_title">Download app</div>

        <ul>
          <li className="ios">
            <Link to="/">
              <img src={iosDownloadPic} alt="ios download" />
            </Link>
          </li>
          <li className="android">
            <Link to="/">
              <img src={androidDownloadPic} alt="android download" />
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
